import React from 'react';
import RequestError from './RequestError';

export default class SectionErrorBoundary extends React.Component {
  state = { failed: false, revision: 0 };
  static getDerivedStateFromError() { return { failed: true }; }
  componentDidCatch(error) { console.error('Section could not be displayed:', error); }
  render() {
    if (this.state.failed) return <RequestError message='This section could not be displayed. Your other sections are still available.' onRetry={() => this.setState(state => ({ failed: false, revision: state.revision + 1 }))} />;
    return <React.Fragment key={this.state.revision}>{this.props.children}</React.Fragment>;
  }
}
